import { render, staticRenderFns } from "./DContentSecurityPreview.vue?vue&type=template&id=1310c5dc&"
import script from "./DContentSecurityPreview.vue?vue&type=script&lang=js&"
export * from "./DContentSecurityPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports